export const MENSAGENS_AGENDADAS_DESIGN = {
    page: {
        container: "flex flex-col h-[calc(100vh-64px)] overflow-hidden",
        contentWrapper: "flex-1 overflow-hidden p-6 gap-6 flex flex-col min-h-0",
        card: "bg-white rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full overflow-hidden transition-all duration-300 ring-1 ring-black/5"
    },
    header: {
        container: "sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b border-gray-100/50 px-6 py-4 shadow-sm transition-all duration-300",
        wrapper: "flex flex-col md:flex-row md:items-center justify-between gap-4",
        left: "flex flex-wrap items-center gap-4 flex-1",
        iconContainer: "p-2 bg-[#7C3AED]/10 rounded-lg",
        icon: "text-[#7C3AED]",
        titleBox: "",
        title: "text-sm font-semibold text-gray-900",
        subtitle: "text-[10px] text-gray-500",
        divider: "h-8 w-px bg-gray-200 hidden md:block mx-2",
        filters: "flex flex-wrap items-end gap-3 flex-1",
        right: "flex flex-col md:flex-row items-center gap-3 w-full md:w-auto"
    },
    filters: {
        label: "text-xs font-medium text-gray-500 mb-1 block",
        selectContainer: "w-[180px]",
        searchContainer: "relative group w-full md:w-auto",
        searchIcon: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400 group-focus-within:text-[#7C3AED] transition-colors",
        input: "w-full md:w-[200px] pl-9 h-9 bg-gray-50 border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 hover:border-[#7C3AED]/50 transition-all text-sm rounded-lg",
        clearButton: "absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-400 hover:text-red-500"
    },
    table: {
        header: "bg-white p-2",
        headCell: "text-xs font-semibold text-gray-500 uppercase tracking-wider",
        row: "hover:bg-gray-50/50 transition-colors border-b border-gray-100 last:border-0",
        cell: "p-4 text-sm text-gray-700",
        statusBadge: {
            base: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium",
            active: "bg-green-100 text-green-800",
            inactive: "bg-gray-100 text-gray-800"
        }
    },
    dialog: {
        content: "flex flex-col gap-0 p-0 w-full sm:max-w-[800px] h-[90vh] sm:h-[800px] max-h-[90vh] rounded-xl overflow-hidden bg-white shadow-2xl",
        header: "px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-white shrink-0",
        title: "text-xl font-bold text-gray-900",
        body: "flex-1 overflow-y-auto px-6 py-6 scroll-smooth",
        footer: "px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-between items-center shrink-0",
        sectionTitle: "text-lg font-medium text-gray-900 mb-1",
        sectionSubtitle: "text-sm text-gray-500 mb-6",
        formGrid: "grid grid-cols-1 gap-6",
        label: "block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2"
    }
};
